// The cash business day, exactly as the server computes it.
//
// Mirrors businessDate() in Library supabase/functions/cash-drawer-count
// (and the DB's to_business_date()): the day rolls over at 3:00 AM
// America/Chicago, DST-correct via Intl. The server files every opening and
// closing count under THIS date and ignores whatever date the page is showing,
// so the page must agree with it to the hour. A page that offers a count on a
// different day files it under today instead — that is how a $0 close for
// 2026-09-22 landed on 2026-09-23 and hid that night's Closing Wizard.
//
// Not the same cutover as src/lib/serviceDate.ts (6:00 AM, bar service day).
export function cashBusinessDate(now: Date = new Date()): string {
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Chicago",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    hour12: false,
  });
  const p: Record<string, string> = {};
  for (const part of fmt.formatToParts(now)) p[part.type] = part.value;
  let hour = parseInt(p.hour, 10);
  if (hour === 24) hour = 0; // some runtimes render midnight as '24'
  const ctWall = Date.UTC(+p.year, +p.month - 1, +p.day, hour, 0, 0);
  return new Date(ctWall - 3 * 3600 * 1000).toISOString().slice(0, 10);
}
